import * as Sentry from '@sentry/react';
import type { User } from '@sentry/react';

import { LogLevel, SentryLogLevel } from '../constants';
import { Handler } from './types';

export default class SentryHandler implements Handler {
  user: User | null = null;

  // oxlint-disable-next-line typescript/no-explicit-any
  log(level: LogLevel, message: string, error: any): void {
    if (error && error instanceof Error) {
      Sentry.withScope((scope) => {
        scope.setExtra('message', message);
        Sentry.captureException(error);
      });
    } else {
      Sentry.withScope((scope) => {
        scope.setExtra('error', error);
        Sentry.captureMessage(message, SentryLogLevel[level]);
      });
    }
  }

  setUser(user: User | null): void {
    this.user = user;
    Sentry.setUser(user);
  }
}
